module.exports = __webpack_public_path__ + "media/images/icons/dots-e7a67cc7f83519c7c32f0f5214e2627c.png";